import { Injectable } from '@angular/core';
import { InventoryReplenishDataEditorService } from './inventory-replenish-data-editor.service';

@Injectable()
export class InventoryReplenishKeyEventHandlerService {

    // To identify and ignore focusin events from mouseclick
  public focusedProperty: string;

  // To identify and ignore focusin events from mouseclick
  public clickFocusedCellId: string;
  // To ignore false keypress/focusout call triggers
  public lastEditKeyPressListnerInvocationTime: number = 0;

  // Editor Service for Data Table
    constructor(
    public dataEditor: InventoryReplenishDataEditorService) { }

  // Function called on focusin events(click/tab) to set focusedcell/rowid
  public setFocusedCell(row: any, property: any) {
    this.focusedProperty = property;
    this.clickFocusedCellId = property;
  }

  /* Function that is listened by directive set-focus to focus the cell based on
    this.lastFocusedRowIndex & row.focusedCellId
    row.focusedCellId can be set from any external functions like from table-editor service etc.
    Also it ensures that no false trigger happens due to (focusin)
    events using mouse or any other interaction(uses this.clickFocusedCellId). */
  public isFocused(row: any, colProp: any) {
    if (colProp === row.focusedCellId && colProp !== this.clickFocusedCellId) {
      return true;
    } else {
      return false;
    }
  }

  public propertyFocusedOut(cells: any, property: any) {
    if (cells[property] && cells[property].isEdited === true) {
      return false;
    }
    return true;
  }

  /* Function that listens to Enter/Tab keypress on input fields in edit mode
  and calls respective functions in case of EA fields*/
//   public editKeyPressListner(event: any) {
//     if (event.keyCode === 9 )  {
//         const storerValue: string =  event.target['value'];
//         this.dataEditor.setStorer(storerValue);
//         this.dataEditor.onStorerChange();
//     }
//   }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/inventory-replenish/services/inventory-replenish-detail-view-key-event-handler.service.ts